import { User } from "oidc-client-ts";
import { ReactNode } from "react";

/**
 * Les rôles possibles, correspondant aux group names Cognito.
 */
export enum Role {
    CONSULTANT = "eu-west-1_bRqPkYBv6_Accenture-AzureAD",
    BD         = "BD",
    ADMIN      = "ADMIN",
}

/**
 * Profil utilisateur enrichi avec la liste de ses rôles.
 */
export interface UserProfile {
    sub:            string;
    email:          string;
    email_verified: boolean;
    name?:          string;
    given_name?:    string;
    family_name?:   string;
    picture?:       string;
    roles:          Role[];
}

/**
 * État basique de l’authentification (issu de react-oidc-context).
 */
export interface AuthState {
    isAuthenticated: boolean;
    user:            User | null;
    isLoading:       boolean;
    error:           string | null;
}

/**
 * Type complet retourné par useAuth().
 */
export interface AuthContextType extends AuthState {
    login:       () => Promise<void>;
    logout:      () => Promise<void>;
    signup:      () => Promise<void>;
    userInfo:    UserProfile;
    getFullName: () => string;
}

/**
 * Props du provider d’authentification.
 */
export interface AuthProviderProps {
    children: ReactNode;
}
